// extracted by mini-css-extract-plugin
module.exports = {"error-text":"error-component_error-text__j040D","error-container":"error-component_error-container__SeZRq"};